const Loading = () => {
  return (
    <div className="fixed inset-0 bg-white z-50 flex items-center justify-center">
      {/*<div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-theme-color">*/}
      {/*  Loading...*/}
      {/*</div>*/}
      <div className="flex flex-col">
        <div className="flex flex-row space-x-8">
          <div className="w-16 h-16 rounded-full animate-spin border-y-4 border-solid border-blue-500 border-t-transparent">
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loading;
